// extracted by mini-css-extract-plugin
export var link = "_up-0";